import Axios from "axios";
import Cookies from 'js-cookie';

export const BaseURL = "https://api.tonaliteh.com/";
export const BaseAPI = "https://api.tonaliteh.com/api/";
export const AxiosPublic = Axios.create({
  baseURL: BaseAPI,
  headers: {
    "Content-Type": "application/json",
  },
});
export const getToken = () => {
  const token = Cookies.get('token')
  return token ? JSON.parse(token) : null
}

export const AxiosPrivate = Axios.create({
  baseURL: BaseAPI,
  headers: {
    Accept: "application/json",
    Authorization: `${getToken()?.token_type} ${getToken()?.access_token}`,
  },
});
